var _defs, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointRoadMarkingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointRoadMarking_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,0V32H28V0Zm6,31H8V27h2Zm0-9H8V18h2Zm0-8H8V10h2Zm0-8H8V2h2ZM23.26,18,20.5,15.27,17.37,18.4a1,1,0,0,0-.3.71V27h-4V17.87a2,2,0,0,1,.59-1.42L15.13,15l2.54-2.55L14.91,9.68,25.43,7.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointRoadMarkingSvg);
export default __webpack_public_path__ + "static/media/NovapointRoadMarking_svg.f03b233f2705e92879765728ce4e8889.svg";
export { ForwardRef as ReactComponent };